<template>
  <footer class="mg-footer">
    <div class="mg-footer__bg" aria-hidden="true">
      <div class="mg-footer__orb"></div>
    </div>

    <div class="mg-container mg-footer__inner">
      <div class="mg-footer__top">
        <div class="mg-footer__brand">
          <router-link to="/" class="mg-footer__logo no-router-link-active">
            <img src="@/assets/MGLogo.png" alt="Money Guided" height="28" />
          </router-link>
          <p class="mg-footer__tagline">
            Feel-good financial outcomes. Built for teams, paid for by employers.
            Nothing to sell, no commission, and member data that never gets shared.
          </p>
        </div>

        <nav class="mg-footer__nav" aria-label="Footer">
          <div class="mg-footer__col">
            <span class="mg-footer__heading">Product</span>
            <router-link to="/features" class="mg-footer__link">Features</router-link>
            <router-link to="/employers" class="mg-footer__link">Employers</router-link>
            <router-link to="/guide" class="mg-footer__link">Guide</router-link>
            <router-link to="/about" class="mg-footer__link">About</router-link>
          </div>

          <div class="mg-footer__col">
            <span class="mg-footer__heading">Help</span>
            <router-link to="/faq" class="mg-footer__link">FAQs</router-link>
            <a href="#" class="mg-footer__link" v-b-modal.contact-modal>Contact us</a>
          </div>

          <div class="mg-footer__col">
            <span class="mg-footer__heading">Legal</span>
            <router-link to="/policy" class="mg-footer__link">Privacy policy</router-link>
            <router-link to="/terms" class="mg-footer__link">Terms of use</router-link>
          </div>
        </nav>
      </div>

      <hr class="mg-footer__rule" />

      <div class="mg-footer__bottom">
        <p class="mg-footer__disclaimer">
          SYSO Limited trading as Money Guided is acting as an agent of TrueLayer,
          who is providing the regulated Account Information Service, and is
          Authorised and Regulated by the Financial Conduct Authority under the
          Payment Services Regulations 2017 and the Electronic Money Regulations
          2011 (Firm Reference Number: 903037).
        </p>
        <div class="mg-footer__meta">
          <span>&copy; {{ year }} Money Guided&nbsp;&reg;</span>
          <span class="mg-footer__dot" aria-hidden="true">&middot;</span>
          <a href="#" class="mg-footer__meta-link" v-b-modal.contact-modal>help@moneyguided.com</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.mg-footer {
  position: relative;
  background: var(--mg-grad-hero);
  color: #fff;
  padding: clamp(56px, 7vw, 96px) 0 clamp(28px, 3vw, 40px);
  overflow: hidden;
  isolation: isolate;
}
.mg-footer__bg { position: absolute; inset: 0; z-index: -1; }
.mg-footer__orb {
  position: absolute;
  width: 520px;
  height: 520px;
  bottom: -260px;
  left: -120px;
  border-radius: 50%;
  background: var(--mg-peach-deep);
  filter: blur(110px);
  opacity: 0.35;
}

.mg-footer__top {
  display: grid;
  grid-template-columns: 1.1fr 2fr;
  gap: clamp(32px, 5vw, 80px);
  align-items: start;
}

.mg-footer__brand { text-align: left; }
.mg-footer__logo {
  display: inline-block;
  margin-bottom: var(--sp-4);
  border-bottom: 0 !important;
}
.mg-footer__logo img { display: block; }
.mg-footer__tagline {
  font-size: 0.9rem;
  line-height: var(--lh-body);
  color: rgba(255, 255, 255, 0.65);
  margin: 0;
  max-width: 32ch;
}

.mg-footer__nav {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(24px, 3vw, 48px);
}
.mg-footer__col {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
}
.mg-footer__heading {
  font-size: var(--fs-tiny);
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--mg-peach);
  margin-bottom: 4px;
}
.mg-footer__link {
  color: rgba(255, 255, 255, 0.78);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: color var(--dur-fast) var(--ease-out),
              transform var(--dur-fast) var(--ease-out);
  width: max-content;
  border-bottom: 0 !important;
}
.mg-footer__link:hover,
.mg-footer__link:focus-visible {
  color: #fff;
  transform: translateX(2px);
  outline: none;
}

.mg-footer__rule {
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  margin: clamp(36px, 4vw, 56px) 0 clamp(20px, 2.5vw, 32px);
}

.mg-footer__bottom {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: clamp(20px, 3vw, 40px);
  align-items: end;
}
.mg-footer__disclaimer {
  font-size: 0.72rem;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.45);
  margin: 0;
  font-style: italic;
  max-width: 70ch;
}
.mg-footer__meta {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.55);
}
.mg-footer__dot { color: rgba(255, 255, 255, 0.3); }
.mg-footer__meta-link {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 1px;
  transition: color var(--dur-fast) var(--ease-out),
              border-color var(--dur-fast) var(--ease-out);
}
.mg-footer__meta-link:hover {
  color: var(--mg-peach);
  border-bottom-color: var(--mg-peach);
}

@media (max-width: 900px) {
  .mg-footer__top {
    grid-template-columns: 1fr;
  }
  .mg-footer__nav { grid-template-columns: repeat(3, 1fr); }
  .mg-footer__bottom {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .mg-footer__meta { justify-content: center; }
  .mg-footer__disclaimer { text-align: center; margin: 0 auto; }
  .mg-footer__brand { text-align: center; }
  .mg-footer__tagline { margin-left: auto; margin-right: auto; }
  .mg-footer__col { align-items: center; text-align: center; }
  .mg-footer__link { width: auto; }
}
@media (max-width: 560px) {
  .mg-footer__nav { grid-template-columns: 1fr; gap: var(--sp-5); }
}
</style>
